import React, { useEffect, useState, useMemo } from "react";
import usePageInfo from "../../hooks/usePageInfo";
import {
  enDaily,
  enMonthly,
  enWeekly,
  formatDate,
  formatDateNum,
  formatDay,
  formatMonth,
  formatWeek,
  formatYear,
} from "../../functions/DateConverter";
import { getWeekOfMonth } from "../../functions/DateConverter";

function Header({
  leftSide,
  rightSide,
  currentDate,
  page,
  i18n,
  isCalendar = true,
}) {
  return (
    <div className="header-class">
      <button className="header-button" id="Navbar" onClick={leftSide}></button>
      <div className="header-desc">
        {i18n.language === "ko"
          ? page === "daily"
            ? `${formatYear(currentDate)} ${formatMonth(
                currentDate
              )} ${formatDateNum(currentDate)} ${formatDay(currentDate)}`
            : page === "weekly"
            ? `${formatYear(currentDate)} ${formatMonth(
                currentDate
              )} ${formatWeek(currentDate)}`
            : page === "monthly"
            ? `${formatYear(currentDate)} ${formatMonth(currentDate)} `
            : ""
          : page === "daily"
          ? enDaily(currentDate)
          : page === "weekly"
          ? enWeekly(currentDate)
          : page === "monthly"
          ? enMonthly(currentDate)
          : ""}
      </div>
      {isCalendar && (
        <button className="header-button" id="Calendar" onClick={rightSide}>
          {/* 캘린더 아이콘 등 */}
        </button>
      )}
    </div>
  );
}

export default Header;
